<template>
    <el-table
    :data="huonekortit"
    @selection-change="handleSelectionChange"
    row-key="id"
    >
        <el-table-column 
        type="selection" 
        v-if="selectable" 
        width="55"
        reserve-selection />
        <el-table-column label="Tilanimike" prop="tilanimike.nimi"></el-table-column>
        <el-table-column label="Täsmennys" prop="toiminta" show-overflow-tooltip></el-table-column>
        <el-table-column label="Status" prop="status">
            <template #default="scope">
                <ComStatusTag :status="scope.row.status"></ComStatusTag>
            </template>
        </el-table-column>
        <el-table-column label="Vastuuyksikkö" prop="vastuuyksikko.nimi"></el-table-column>
        <el-table-column label="Tilat" show-overflow-tooltip>
            <template #default="scope">
                {{ formatTilat(scope.row.tilat) }}
            </template>
        </el-table-column>
    </el-table>
</template>

<script setup lang="ts">
import { HuonekorttiResponse } from "@/api/models/huonekortti-response"
import { useHuonekorttiTable } from "./huonekorttiTable"
import huonekorttiTableStore from "./huonekorttiTableStore"
import { computed, onUnmounted, PropType } from "vue"
import ComStatusTag from "@/components/common/ComStatusTag.vue"

const props = defineProps({
    huonekortit: {
        type: Object as PropType<HuonekorttiResponse[]> | undefined,
    },
    selection: {
        type: Boolean,
        default: false,
    },
})
const { formatTilat } = useHuonekorttiTable()
const setSelected = huonekorttiTableStore.methods.setSelected
const selectable = computed(() => props.selection)

const handleSelectionChange = (val: HuonekorttiResponse[]) => {
    setSelected(val.map((item) => item.id))
}

// Tyhjennä valinta storesta kun taulukko poistuu näkymästä,
// jottei vanhentunut valinta jää muille raporttinäkymille
onUnmounted(() => setSelected([]))
</script>
